import * as statusIcons from "../Icons/status";
import styles from "./index.module.scss";
import { Text } from "../Type/index";
import { statusType, findStatus } from "../../utils/status/index";

type PropsType = {
  status: statusType;
};

const StatusPill = ({ status }: PropsType) => {
  const Icon = statusIcons[status];

  return (
    <Text className={styles.text} size="small" weight="bold">
      {statusIcons[status] && <Icon className={styles.icon} />}
      {findStatus(status).label}
    </Text>
  );
};

export default StatusPill;
